import { Components } from '@mui/material/styles';

export const MuiLink: Components['MuiLink'] = {};
